import React, { useRef, useState } from "react";
import ModalFrame from "./ModalFrame";

// Bevestiging vóór een (destructieve) actie. Vervangt window.confirm().
//
// Props:
//   open, title, message (tekst of node), confirmLabel (standaard "Bevestigen"),
//   cancelLabel (standaard "Annuleren"), tone "danger" | "default",
//   onConfirm (mag een Promise teruggeven: de knoppen staan dan op "Bezig…"),
//   onCancel (Esc, overlayklik, ×-knop en Annuleren), children (extra inhoud, bv. een detailregel),
//   confirmDisabled (bevestigen nog niet mogelijk, bv. een verplichte reden ontbreekt).
//   `onClose` is een alias van onCancel (backwards compat).
// De focus start op Annuleren: een per ongeluk Enter mag niets weggooien.
// Z-index: altijd --z-dialog, dus ook boven een open Drawer of Modal.
export default function ConfirmDialog({
  open,
  title = "Bevestigen",
  message,
  confirmLabel = "Bevestigen",
  cancelLabel = "Annuleren",
  tone = "default",
  onConfirm,
  onCancel,
  onClose,
  children,
  confirmDisabled = false,
}) {
  const cancelRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const cancel = onCancel || onClose;

  const handleConfirm = async () => {
    setBusy(true);
    try {
      await onConfirm?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ModalFrame
      open={open}
      title={title}
      width={460}
      variant="modal"
      className="confirm-dialog"
      stacked
      initialFocusRef={cancelRef}
      onClose={busy ? undefined : cancel}
      footer={
        <>
          <button ref={cancelRef} type="button" className="btn-outline-green" onClick={() => cancel?.()} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`btn confirm-dialog__confirm${tone === "danger" ? " btn--danger" : ""}`}
            onClick={handleConfirm}
            disabled={busy || confirmDisabled}
          >
            {busy ? "Bezig…" : confirmLabel}
          </button>
        </>
      }
    >
      {children}
      {message ? <p className="confirm-dialog__message">{message}</p> : null}
    </ModalFrame>
  );
}
